import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, MenuItem, Pagination, Select, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';

import { useSelector } from 'react-redux'
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function AgentList() {
    const { profile } = useSelector(state => state.profile)

    const [data, setData] = useState([])
    const [name, setName] = useState('')
    const [agentStatus, setagentStatus] = useState('ทั้งหมด')
    const [year, setYear] = useState(null)
    const [sdate, setSdate] = useState(null)
    const [edate, setEdate] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams()
    let p = searchParams.get('p') || ''
    let s = searchParams.get('s') || ''
    let y = searchParams.get('y') || ''
    let e = searchParams.get('e') || ''
    let a = searchParams.get('a') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    // const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`agents?branchNo=${profile?.BranchNo?.BranchNo}&name=${p}&sdate=${s}&edate=${e}&agentStatus=${a}&expiredYear=${y}&page=${page}&limit=${rowsPerPage}`)
        // const res = await api.get(`agents?name=${p}&sdate=${s}&edate=${e}&page=${page}&limit=${rowsPerPage}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    const handleSearch = async (e) => {
        e.preventDefault()
        setSearchParams({ p: name, y: year ? dayjs(year).format('YYYY') : '', s: sdate ? dayjs(sdate).format('YYYY-MM-DD') : '', e: edate ? dayjs(edate).format('YYYY-MM-DD') : '', a: agentStatus })

    }
    useEffect(() => {
        if (profile) {
            getData()
        }
    }, [p, y, s, e, a, page, profile])

    function checkExpireDate(expireDate, ExtentionStatus) {

        if (expireDate) {
            const datenow = new Date();
            const _expireDate = new Date(expireDate);
            const yearExpire = _expireDate.getFullYear();
            const addLincenseStart = new Date(yearExpire, 9);

            const addLincenseEnd = new Date(yearExpire, 11, 31, 11, 59, 59);
            if (datenow.getTime() >= addLincenseStart.getTime()) {
                return true;
            } else {
                return false;
            }

        }

        // return false;

    }

    return (
        <div>
            <Page>
                <form onSubmit={e => handleSearch(e)}>
                    <div class="container-fluid">
                        <div class="row mt-3">
                            <div class="col-md-3">
                                <Box className='backgroundField'>
                                    <TextField value={name} onChange={e => setName(e.target.value)} variant="standard" fullWidth placeholder="ค้นหาเลขที่ตัวเเทน-ชื่อร้านค้า"
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-md-2">
                                <Box className='backgroundField'>
                                    <MobileDatePicker
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={sdate} onChange={e => setSdate(e)}
                                        slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่เริ่มต้น', fullWidth: true, InputProps: { disableUnderline: true }, value: sdate } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />


                                </Box>
                            </div>
                            <div class="col-md-2">
                                <Box className='backgroundField'>
                                    <MobileDatePicker
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={edate} onChange={e => setEdate(e)}
                                        minDate={sdate}
                                        slotProps={{ textField: { variant: 'standard', placeholder: 'วันที่สิ้นสุด', fullWidth: true, InputProps: { disableUnderline: true }, value: edate } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />

                                </Box>
                            </div>
                            <div class="col-md-2">
                                <Box className='backgroundField'>
                                    <MobileDatePicker
                                        views={['year']}
                                        format="YYYY"
                                        // dayOfWeekFormatter={(day) => `${day}`}
                                        value={year} onChange={e => setYear(e)}
                                        slotProps={{ textField: { variant: 'standard', placeholder: 'ปีหมดอายุ', fullWidth: true, InputProps: { disableUnderline: true }, value: year } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />


                                </Box>
                            </div>
                            <div class="col-md-2">
                                <Box className='backgroundField'>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={agentStatus} onChange={e => setagentStatus(e.target.value)} disableUnderline >
                                            {['ทั้งหมด', 'ปกติ', 'ใกล้สิ้นอายุ', 'สิ้นอายุ']?.map((x) => (
                                                <MenuItem value={x}>{x}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>
                            <div class="col-md-1">

                                <Button className='ButtomSearch' type="submit" variant='contained'>ค้นหา</Button>

                            </div>
                        </div>
                    </div>
                </form >
            </Page>
            <Page>
                <div class="container-fluid">
                    <div class=" d-flex row justify-content-between align-items-baseline">
                        <div class="col-lg-5 col-md-12 text-left ">
                            <label class="title-content mb-4">
                                รายการตัวแทนจำหน่าย
                            </label>
                        </div>
                        <div class="col-lg-3 col-md-12 text-end px-4">
                            <Link to={`/agent/agent-list/add`}>
                                <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                            </Link>
                        </div>

                    </div>

                    <div class="listData row">
                        {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                            <div class="col-md-12 table-responsive-sm pb-3" style={{ overflowX: 'auto' }}>
                                <table class="table table-borderless " >
                                    <thead>
                                        <tr>
                                            <th class="text-center"></th>
                                            <th class="text-center">ที่</th>
                                            <th class="text-center">วันที่ทำรายการ</th>

                                            <th class="text-center">ชื่อร้านค้า</th>
                                            <th class="text-center">หน่วยงานที่เลือกสมัคร</th>
                                            <th class="text-center">เลขที่ตัวแทน</th>
                                            <th class="text-center">ชื่อตัวแทน</th>
                                            <th class="text-center">วันหมดอายุ</th>
                                            <th class="text-center">ผู้อนุมัติ</th>
                                            <th class="text-center">สถานะ</th>
                                            <th class="text-center">ดำเนินการ</th>


                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        {data?.items?.map((x, i) => (
                                            <tr className={id === x?.RequestNo ? 'active' : ''}>
                                                <td style={{ width: '80px', textAlign: 'end' }}>
                                                    {x?.ReadStatus === 'N' && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) ? <span style={{ color: 'limegreen', }}> NEW!</span> : x?.ReadStatus === 'U' && (profile?.BranchNo?.BranchNo === x?.BranchNo?.BranchNo) ? <span style={{ color: 'coral', }}> UPDATE!</span> : <></>}
                                                </td>
                                                <td class="text-center"> {(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                                <td class="text-center"> {x?.CreateDate && dayjs(x?.CreateDate).format('DD/MM/BBBB')}</td>

                                                <td class="text-center">{x?.ContactName}</td>
                                                <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                                <td class="text-center">{x?.AgentNumber}</td>
                                                <td class="text-center">{x?.Fname} {x?.Lname}</td>
                                                <td class="text-center">{x?.AgentExpireDate && dayjs(x?.AgentExpireDate).format('DD/MM/BBBB')}</td>
                                                <td class="text-center">{x?.ApproveId}</td>
                                                <td class="text-center">
                                                    {
                                                        x?.Status === 'U' ?
                                                            <span class="status-inactive">
                                                                รอยืนยันอีเมล
                                                            </span> : x?.Status === 'W' && x?.ExtentionStatus === 'Y' ?
                                                                <span class="status-wait">
                                                                    ยื่นคำขอสมัครตัวแทน
                                                                </span> : x?.Status === 'Y' && x?.ExtentionStatus === 'W' ?
                                                                    <span class="status-wait">
                                                                        ยื่นคำขอต่ออายุ
                                                                    </span> : x?.Status === 'Y' && x?.ExtentionStatus === 'Y' ?
                                                                        <span class="status-active">
                                                                            เสร็จสิ้น
                                                                        </span> : x?.Status === 'N' ?
                                                                            <span class="status-inactive">
                                                                                ยกเลิก
                                                                            </span> : x?.Status === 'E' ?
                                                                                <span class="status-inactive">
                                                                                    หมดอายุ
                                                                                </span> : x?.Status === 'DR' ?
                                                                                    <span class="status-wait">
                                                                                        ขอเอกสารเพิ่มเติม
                                                                                    </span> : x?.Status === 'DU' ?
                                                                                        <span class="status-wait">
                                                                                            ตรวจสอบเอกสารเพิ่มเติม
                                                                                        </span> : ''}
                                                </td>
                                                <td class="text-center">
                                                    <Link to={`/agent/agent-list/${x?.RequestNo}`}>
                                                        <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }} onClick={() => setSearchParams({ id: x?.RequestNo, page: page, p: p, s: s, e: e, })}>เรียกดู</Button>
                                                    </Link>

                                                    {checkExpireDate(x?.AgentExpireDate) && x?.AgentNumber ? <Link to={`/agent/agent-list/${x?.RequestNo}?mode=addLicense`}><Button variant='contained' color='error' sx={{ marginLeft: '10px' }} onClick={() => setSearchParams({ id: x?.RequestNo, page: page, p: p, s: s, e: e, })}>ต่ออายุ</Button></Link> : ''}

                                                </td >
                                            </tr >
                                        ))}

                                    </tbody >
                                </table >
                            </div >}
                        <div class="col-md-12 text-center mt-4">
                            <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, p: p, s: s, e: e, id: id })} shape="rounded" />

                        </div>
                    </div >
                </div >
            </Page >
        </div >
    )
}
